module.exports = __webpack_public_path__ + "images/icons_v2/help-filled-ac81a323.svg";